import NotificationServiceModel from '@/models/NotificationServiceModel';
import doc                      from '@widesk-core/decorators/doc';

type NewsletterReference = 'newsletter_paris' | 'newsletter_sud' | 'newsletter_centre' | 'newsletter_nihongo' | 'newsletter_ecg';

@doc.path('/stonecode_notification_channels/{?id}')
export default class NewsletterModel extends NotificationServiceModel {

	get label(): string {
		return this.get('label', '');
	}

	@doc.string declare reference: NewsletterReference;
}